class Popover {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-toggle="popover"]'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.each((index, element) => {
			let $element = $(element);
			let settings = Object.assign({
				placement: 'top',
				trigger: 'hover',
				html: true
			}, $element.data('config'));
			$element.popover(settings);
		});
	}
}

export default Popover;